var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjects(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.75 -6.10352e-05C23.6783 -6.10352e-05 24.5685 0.368688 25.2249 1.02507C25.8813 1.68144 26.25 2.57168 26.25 3.49994H10.5C9.57174 3.49994 8.6815 3.86869 8.02513 4.52506C7.36875 5.18144 7 6.07168 7 6.99994V27.9999C6.07174 27.9999 5.1815 27.6312 4.52513 26.9748C3.86875 26.3184 3.5 25.4282 3.5 24.4999V3.49994C3.5 2.57168 3.86875 1.68144 4.52513 1.02507C5.1815 0.368688 6.07174 -6.10352e-05 7 -6.10352e-05L22.75 -6.10352e-05Z",
    fill: "#05386B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 34.9999C11.3217 34.9999 10.4315 34.6312 9.77513 33.9748C9.11875 33.3184 8.75 32.4282 8.75 31.4999V8.74994C8.75 7.82168 9.11875 6.93144 9.77513 6.27507C10.4315 5.61869 11.3217 5.24994 12.25 5.24994H28C28.9283 5.24994 29.8185 5.61869 30.4749 6.27507C31.1313 6.93144 31.5 7.82168 31.5 8.74994V31.4999C31.5 32.4282 31.1313 33.3184 30.4749 33.9748C29.8185 34.6312 28.9283 34.9999 28 34.9999H12.25ZM23.625 28.8749L24.3425 26.9674L26.25 26.2499L24.3425 25.5324L23.625 23.6249L22.9075 25.5324L21 26.2499L22.9075 26.9674L23.625 28.8749ZM18.4065 27.2142L20.0725 22.7324L24.5 21.0454L20.0725 19.3584L18.4065 14.8749L16.7405 19.3584L12.313 21.0454L16.7405 22.7324L18.4065 27.2142ZM24.5 18.3749L25.4573 15.8322L28 14.8749L25.4573 13.9177L24.5 11.3749L23.5428 13.9177L21 14.8749L23.5428 15.8322L24.5 18.3749Z",
    fill: "#05386B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.105ee6a6ca33649db11d6199a3dafef0.svg";
export { ForwardRef as ReactComponent };